import React, { Component } from 'react';
import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";
import { Roles } from './auth/rolesPermissions';
import { marketplacesLogoList, ProfileLevels, couriersLogoList, warehousesList, provinces, ajax, getReminders } from './components/globals';
import { Languages } from './components/languages';
import MainMenu from './components/mainMenu';
import Login from './components/login';
import { MessageBox, MessageBoxFluid, LoaderBox, ErrorMessageBox } from './components/utilities';
import { PrivacyMessageBoxFluid } from './components/privacyConsent';

import { SenderAddresses, Notifications, Company, Labels, PackageConfig, RecipientAddresses } from './pages/settings';
import Countersigns from './pages/countersigns';
import Storaging from './pages/storaging';
import Tracking from './pages/tracking';
import UserProfile from './pages/user';
import { OrdersReturned, OrderHistory, DiscardedOrdersList, Bordero } from './pages/orders';
import { How2SendaPro } from './pages/how2sendapro';
import { MySendaPro } from './pages/mysendapro';
import { SingleOrderCreation } from './pages/singleordercreation';
import { OrderCreation } from './pages/ordercreation';
import { OrdersList } from './pages/orderslist';
import Couriers from './pages/couriers';
import Marketplaces from './pages/marketplaces';
import CreditBox from './pages/creditBox';
import { PayPalScriptProvider } from "@paypal/react-paypal-js";
import MonetaWebStart from './pages/monetaWebStart';
import MonetaWebResult from './pages/monetaWebResult';
import MonetaWebFailed from './pages/monetaWebFailed';
import EbayWebAccessResult from "./pages/ebayWebAccessResult";

import { WarehouseSingleOrderCreation } from './pages/Warehouse/singleordercreation';
import WarehouseOrdersHistory from './pages/Warehouse/ordersHistory';
import WarehouseStock from './pages/Warehouse/stock';
import WarehouseRegisrtyProducts from './pages/Warehouse/registryProducts';
import WarehouseReturnProducts from './pages/Warehouse/returnProducts';
import { ProtectedRoute } from "./auth/protectedRoute"
import { permissions, solutionPermissions, ordersPermissions, connectionsPermissions, settingsSectionPermissions, settingsPermissions, settingsAddressPermissions, settingsAddressRecipientPermissions, warehousePermissions } from "./auth/permissions"
import { hasAnyPermission } from "./helpers/helper"
import { readUserContext, clearUserContext, saveUserContext } from "./auth/sessionService"
import { AuthContext } from "./auth/authContext";
import ForgotPassword from "./pages/forgotPassword";
import ResetPassword from "./pages/resetPassword";
import VerifyRecoveryMail from "./pages/verifyRecoveryMail";

export default class App extends Component {
    static displayName = App.name;
    static contextType = AuthContext;

    constructor(props) {
        super(props);

        this.loggedIn = this.loggedIn.bind(this);
        this.logoutClick = this.logoutClick.bind(this);

        this.generalChecks = this.generalChecks.bind(this);
        this.msgSetProfile_OK = this.msgSetProfile_OK.bind(this);
        this.setInvoicing = this.setInvoicing.bind(this);
        this.popupMessage = this.popupMessage.bind(this);
        this.popupMessageClose = this.popupMessageClose.bind(this);
        this.popupErrorMessage = this.popupErrorMessage.bind(this);
        this.popupErrorMessageClose = this.popupErrorMessageClose.bind(this);
        this.showLoader = this.showLoader.bind(this);
        this.navigateTo = this.navigateTo.bind(this);
        this.privacyConfirmed = this.privacyConfirmed.bind(this);
        this.buildRoute = this.buildRoute.bind(this);
        this.hasCreditBox = this.hasCreditBox.bind(this);
        this.loaderHide = this.loaderHide.bind(this);
        this.uc = null;
        this.pageRef = React.createRef();

        
        let loginSt = true;

        const userContext = readUserContext();

        if (userContext) {
            loginSt = false;
            this.uc = userContext;

            this.reminderTimer = setTimeout(() => {
                this.remindersHandler();
            }, 3000);
        }

        this.state = {
            login: loginSt,
            externalRouting: this.isExternalRouting(),
            msgmodal: 0,
            //forcedSelection: [1, 1, 0],
            genericMsg: {},
            errorMessage: '',
            paypalClientId: '',
            navigateTo: { redirect: "/mysendapro", path: [1, 1, 0] }
        };

        this.leMain = Languages.Main[Languages.selectedLanguage];
        this.setmenu();

        //#region defaultProps for page elements


        Couriers.defaultProps = {
            couriersLogoList: couriersLogoList,
            provincesZip: provinces,
            loaderShow: this.showLoader,
            loaderHide: this.popupMessageClose,
            popupMessage: this.popupMessage,
            popupErrorMessage: this.popupErrorMessage,
            logoutClick: this.logoutClick
        };
        Marketplaces.defaultProps = {
            loaderShow: this.showLoader,
            loaderHide: this.popupMessageClose,
            popUp: this.popupMessage,
            popupErrorMessage: this.popupErrorMessage,
            marketplacesLogoList: marketplacesLogoList,
            logoutClick: this.logoutClick
        };
        OrderCreation.defaultProps = {
            marketplacesLogoList: marketplacesLogoList,
            couriersLogoList: couriersLogoList,
            warehousesList: warehousesList,
            entries: [
                ['Italmondo', '20/12/2020', '182745595936X9V364', 'SDA', 'Amazon', ''],
                ['SupernovaHUB', '22/12/2020', '182745595936X9V362', 'GLS', 'Magento', ''],
                ['Lainate', '21/12/2020', '182745595936X9V367', 'DHL', 'eBay', '']
            ],
            popUp: this.popupMessage,
            navigation: {
                pageSize: { value: 10 },
                pageNo: { value: 0 },
                totalItems: { value: 0 }
            },
            loaderShow: this.showLoader,
            loaderHide: this.popupMessageClose,
            popupMessage: this.popupMessage,
            popupErrorMessage: this.popupErrorMessage,
            userMessageTimeout: 2000,
            logoutClick: this.logoutClick,
            navigateTo: this.navigateTo
        };
        UserProfile.defaultProps = {
            setInvoicing: this.setInvoicing,
            loaderShow: this.showLoader,
            loaderHide: this.popupMessageClose,
            logoutClick: this.logoutClick,
            popupErrorMessage: this.popupErrorMessage,
        };

        SingleOrderCreation.defaultProps = {
            warehouses: warehousesList,
            data: {
                services: {
                    assicurazione: { active: false, value: '', type: 'text', textClass: 'bold', enabled: true },
                    contrassegno: { active: false, value: '', type: 'text', textClass: 'bold', enabled: false },
                    triangulation: { active: false, value: '', type: 'checkbox', textClass: 'bold', enabled: false }

                    /*,pickupDate: { active: false, value: '', type: 'date', textClass: 'bold' }*/
                },
                checkbox: { acceptance: false },
                triangulation: {
                    name: '',
                    surname: '',
                    at: '',
                    address: '',
                    houseNo: '',
                    country: 'ITALIA',
                    city: '',
                    province: '',
                    zip: '',
                    number: '',
                    // email: '',
                    // confirmEmail: '',
                    // note: ''
                },
                sender: {
                    name: '',
                    surname: '',
                    at: '',
                    address: '',
                    houseNo: '',
                    city: '',
                    province: '',
                    zip: '',
                    number: '',
                    email: '',
                    note: ''
                },
                recipient: {
                    name: '',
                    surname: '',
                    at: '',
                    address: '',
                    houseNo: '',
                    country: 'ITALIA',
                    city: '',
                    province: '',
                    zip: '',
                    number: '',
                    email: '',
                    note: ''
                },
                order: {
                    orderNum: ''
                },
                warehouse: null,
            },
            loaderShow: this.showLoader,
            loaderHide: this.popupMessageClose,
            popupErrorMessage: this.popupErrorMessage,
            navigateTo: this.navigateTo,
            logoutClick: this.logoutClick
        };

        OrderHistory.defaultProps = {
            loaderShow: this.showLoader,
            loaderHide: this.popupMessageClose,
            popUp: this.popupMessage,
            popupErrorMessage: this.popupErrorMessage,
            navigation: {
                pageSize: { value: 10 },
                pageNo: { value: 0 },
                totalItems: { value: 0 }
            },
            entries: [],
            logoutClick: this.logoutClick
        };

        OrdersReturned.defaultProps = {
            loaderShow: this.showLoader,
            loaderHide: this.popupMessageClose,
            popUp: this.popupMessage,
            popupErrorMessage: this.popupErrorMessage,
            navigation: {
                pageSize: { value: 10 },
                pageNo: { value: 0 },
                totalItems: { value: 0 }
            },
            entries: [],
            logoutClick: this.logoutClick
        };

        OrdersList.defaultProps = {
            navigation: {
                pageSize: { value: 10 },
                pageNo: { value: 0 },
                totalItems: { value: 0 }
            },
            entries: [
                ['182745595936X9V364', '20/12/2020', 'SDA', 'Veronica Morroni', { val: 'In lavorazione', color: '#f9ae31' }],
                ['182745595936X9V362', '22/12/2020', 'GLS', 'Alberto Girandola', { val: 'Pronta', color: '#0aff00' }],
                ['182745595936X9V367', '21/12/2020', 'DHL', 'Gennaro Forlani', { val: 'In aggiornamento', color: '#5ca0fc' }]
            ],
            loaderShow: this.showLoader,
            loaderHide: this.popupMessageClose,
            popUp: this.popupMessage,
            popupErrorMessage: this.popupErrorMessage,
            navigateTo: this.NavigateTo,
            logoutClick: this.logoutClick
        };
        DiscardedOrdersList.defaultProps = {
            entries: [],
            loaderShow: this.showLoader,
            loaderHide: this.popupMessageClose,
            popUp: this.popupMessage,
            popupErrorMessage: this.popupErrorMessage,
            logoutClick: this.logoutClick
        };
        Bordero.defaultProps = {
            loaderShow: this.showLoader,
            loaderHide: this.popupMessageClose,
            popUp: this.popupMessage,
            popupErrorMessage: this.popupErrorMessage,
            navigation: {
                pageSize: { value: 10 },
                pageNo: { value: 0 },
                totalItems: { value: 0 }
            },
            entries: [],
            logoutClick: this.logoutClick
        };
        Countersigns.defaultProps = {
            loaderShow: this.showLoader,
            loaderHide: this.popupMessageClose,
            popUp: this.popupMessage,
            popupErrorMessage: this.popupErrorMessage,
            navigation: {
                pageSize: { value: 10 },
                pageNo: { value: 0 },
                totalItems: { value: 0 }
            },
            entries: [],
            totals: [{ name: 'cashed', val: '0' }, { name: 'cashin', val: '0' }],
            logoutClick: this.logoutClick
        };

        Storaging.defaultProps = {
            loaderShow: this.showLoader,
            loaderHide: this.popupMessageClose,
            popUp: this.popupMessage,
            popupErrorMessage: this.popupErrorMessage,
            navigation: {
                pageSize: { value: 10 },
                pageNo: { value: 0 },
                totalItems: { value: 0 }
            },
            entries: [],
            totals: [{ name: 'storage', val: '231' }],
            logoutClick: this.logoutClick
        };
        Tracking.defaultProps = {
            loaderShow: this.showLoader,
            loaderHide: this.popupMessageClose,
            popUp: this.popupMessage,
            popupErrorMessage: this.popupErrorMessage,
            data: {
                navigation: {
                    pageSize: { value: 10 },
                    pageNo: { value: 0 },
                    totalItems: { value: 0 }
                },
                entries: []
            },
            logoutClick: this.logoutClick
        };
        Company.defaultProps = { data: { name: '', site: '', email: '', twitter: '', facebook: '', instagram: '' } };
        Labels.defaultProps = {
            data: { defaultLabel: '', additionalTextFirst: '', defaultPackingSlip: '', additionalTextSecond: '' },
            popupMessage: this.popupMessage,
            popupErrorMessage: this.popupErrorMessage,
        };
        PackageConfig.defaultProps = {
            data: { name: '', weight: '', length: '', height: '', depth: '' },
            popupErrorMessage: this.popupErrorMessage,
        };
        Notifications.defaultProps = {
            data: { send: false, delivery: false },
            loaderShow: this.showLoader,
            loaderHide: this.popupMessageClose,
            popupMessage: this.popupMessage,
            popupErrorMessage: this.popupErrorMessage,
            logoutClick: this.logoutClick
        };
        SenderAddresses.defaultProps = {
            loaderShow: this.showLoader,
            loaderHide: this.popupMessageClose,
            popupErrorMessage: this.popupErrorMessage,
            popupMessage: this.popupMessage,
            sections: {
                places: [// IMPORTANT: respect the items order !!!

                ]
            },
            logoutClick: this.logoutClick
        };

        RecipientAddresses.defaultProps = {
            loaderShow: this.showLoader,
            loaderHide: this.popupMessageClose,
            popupErrorMessage: this.popupErrorMessage,
            popupMessage: this.popupMessage,
            sections: {
                places: [

                ]
            },
            logoutClick: this.logoutClick
        };

        MySendaPro.defaultProps = {
            navigateTo: this.navigateTo,
            logoutClick: this.logoutClick,
            loaderShow: this.showLoader,
            loaderHide: this.loaderHide,
        }
        How2SendaPro.defaultProps = {
            navigateTo: this.navigateTo,
            logoutClick: this.logoutClick
        }


        CreditBox.defaultProps = {
            loaderShow: this.showLoader,
            loaderHide: this.popupMessageClose,
            popupMessage: this.popupMessage,
            popupErrorMessage: this.popupErrorMessage,
        };

        MonetaWebStart.defaultProps = {};
        MonetaWebResult.defaultProps = {};
        MonetaWebFailed.defaultProps = {};

        WarehouseSingleOrderCreation.defaultProps = {
            warehouses: warehousesList,
            data: {
                checkbox: { acceptance: false },
                sender: {
                    warehouse: 'Arluno',
                    country: 'ITALIA',
                    city: 'Arluno',
                    province: 'MI',
                },
                recipient: {
                    address: '',
                    country: 'ITALIA',
                    province: '',
                    zip: '',
                    email: ''
                },
                order: {
                    orderNum: ''
                },
                warehouse: null,
            },
            loaderShow: this.showLoader,
            loaderHide: this.popupMessageClose,
            popupErrorMessage: this.popupErrorMessage,
            navigateTo: this.navigateTo,
            logoutClick: this.logoutClick
        };

        WarehouseStock.defaultProps = {
            loaderShow: this.showLoader,
            loaderHide: this.popupMessageClose,
            popUp: this.popupMessage,
            popupErrorMessage: this.popupErrorMessage,
            entries: [],
            totals: [{ name: 'stock', val: '231' }],
            logoutClick: this.logoutClick
        };

        WarehouseOrdersHistory.defaultProps = {
            loaderShow: this.showLoader,
            loaderHide: this.popupMessageClose,
            popUp: this.popupMessage,
            popupErrorMessage: this.popupErrorMessage,
            entries: [],
            totals: [{ name: 'orders', val: '231' }],
            logoutClick: this.logoutClick
        };

        //UIConfirmPopup.defaultProps = {
        //    title: "",
        //    message: "",
        //    highlightedValue: "",
        //    confirmText: "Conferma",
        //    cancelText: "Annulla",
        //    loadingText: "Caricamento...",
        //    icon: "fa-solid fa-circle-question",

        //    danger: false,
        //    warning: false,
        //    loading: false,

        //    showCancelButton: true,
        //    closeOnEscape: true,
        //    closeOnOverlay: true,
        //    autoFocusConfirm: true,

        //    onConfirm: null,
        //    onCancel: null
        //};

        //#endregion defaultProps for page elements
    }

    hasPrivacyConsent() {
        return this.uc != undefined && this.uc.hasOwnProperty("privacyConsent") && this.uc.privacyConsent;

    }

    hasCreditBox() {
        return Boolean(
            this.uc &&
            this.uc.userProfile &&
            this.uc.userProfile.hasCreditBox
        );
    }

    componentDidMount() {
        this.loaderHide();
        // window.process = { ...window.process }
        if (!this.hasPrivacyConsent()) {
            this.popupPrivacyConsent(true);
        }
        else {
            this.loaderHide();
        }
    }



    generalChecks(ev) {
        if (!this.uc.invoicing) {
            this.setState({ msgmodal: 1 });
            return false;
        }
        //this.setState({ forcedSelection: [0, 0, 0] });
        this.navigateTo("");
        this.pageRef.current.scrollTop = 0;
        return true;
    }

    isExternalRouting() {
        if (window.location.pathname) {
            if (window.location.pathname.indexOf("/monetaWebStart") >= 0)
                return "/monetaWebStart";
            else if (window.location.pathname.indexOf("/monetaWebResult") >= 0)
                return "/monetaWebResult";
            else if (window.location.pathname.indexOf("/ebayWebAccessResult") >= 0)
                return "/ebayWebAccessResult";
        }
        return "";
    }

    msgSetProfile_OK(ev) {
        //this.setState({ msgmodal: 0, forcedSelection: [4, 1, 1] 
        this.setState({ msgmodal: 0 });
        this.navigateTo("SET_PROFILE");
        //this.setState({ msgmodal: 0, forcedSelection: [4, 1, 1] });
    }

    navigateTo(page, params) {
        let navigate = {
            redirect: "",
            path: []
        };
        switch (page) {
            case "DASHBOARD":
                navigate.redirect = "/mysendapro";
                //navigate.path = [1, 1, 0];
                this.setState({ navigateTo: navigate });
                break;

            case "ORDERLIST":
                navigate.redirect = "/orders-3";
                //navigate.path = [1, 1, 3];               
                break;

            case "SET_PROFILE":
                navigate.redirect = "/user-1";
                //navigate.path = [4, 1, 1];
                break;

            case "COURIERS":
                navigate.redirect = "/couriers-0";
                //navigate.path = [3, 1, 0];
                break;


            case "MARKETPLACES":
                navigate.redirect = "/marketplaces-0";
                //navigate.path = [3, 1, 0];
                break;

            case "TRACKING":
                navigate.redirect = "/tracking-0";
                //navigate.path = [3, 1, 0];
                break;

            case "ORDERS":
                navigate.redirect = "/orders-1";
                //navigate.path = [3, 1, 0];
                break;

            case "SINGLE-ORDERS":
                navigate.redirect = "/orders-2";
                //navigate.path = [3, 1, 0];
                break;
            case "MARKS":
                navigate.redirect = "/contrassegni-0";
                break;
            case "INVENTORY-MANAGEMENT":
                navigate.redirect = "/giacenze-0";
                break;
            case "CREDITBOXMANAGE":
                if (this.hasCreditBox())
                    navigate.redirect = "/orders-8";
                //navigate.path = [1, 1, 7];

                break;

            default:
                navigate.redirect = "";
                //navigate.path = [0, 0, 0];
                break;

        }
        //if (navigate.path.length > 0) {
        if (params)
            navigate.params = params;
        this.setState({ navigateTo: navigate });
        //}
    }


    privacyConfirmed(has) {

        this.hasPrivacy = has;
        if (!has)
            this.logoutClick();
        else {

            if (this.uc != undefined) {
                this.uc.privacyConsent = true;
                saveUserContext(this.uc);
                //sessionStorage.setItem("userContext", JSON.stringify(this.uc));

            }
            this.popupPrivacyConsent(false);
        }
    }

    setmenu() {
        const userPermission =
            this.uc && Array.isArray(this.uc.permissions)
                ? this.uc.permissions
                : [];
        var le = Languages.Main[Languages.selectedLanguage].menuLabels;//menuSections;

        this.menu = {
            sections:
                [
                    {
                        title: null,
                        items: [{
                            icon: '../images/mainMenu/User.png',
                            title: 'Anonymous',
                            action: '/user-0',
                            className: 'menu-user'
                        }]
                    },
                    {
                        title: null,
                        items:
                            [
                                {
                                    icon: '../images/mainMenu/HowToSendaPro.png',
                                    title: le.howToSendapro,
                                    action: '/how2sendapro',
                                    show: () => (!hasAnyPermission(userPermission, warehousePermissions))
                                },
                                {
                                    icon: '../images/mainMenu/MySendapro.png',
                                    title: le.mySendapro,
                                    action: '/mysendapro'
                                }
                            ],
                    },
                    {
                        title: le.solutions,
                        show: () => (hasAnyPermission(userPermission, solutionPermissions)),
                        items:
                        [
                            {
                                icon: '../images/mainMenu/Orders.png',
                                title: le.orders,
                                show: () => (hasAnyPermission(userPermission, ordersPermissions)),
                                subs: [
                                    {
                                        title: le.ordersCreate,
                                        action: '/orders-1',
                                        show: () => (userPermission.includes(permissions.ORDERS_CREATE))
                                    },
                                    {
                                        title: le.ordersCreateSingle,
                                        action: '/orders-2',
                                        show: () => (userPermission.includes(permissions.ORDERS_CREATE_SINGLE))
                                    },
                                    {
                                        title: le.ordersHistory,
                                        action: '/orders-6',
                                        show: () => (userPermission.includes(permissions.ORDERS_HISTORY))
                                    },
                                    {
                                        title: le.ordersBordero,
                                        action: '/orders-5',
                                        show: () => (userPermission.includes(permissions.ORDERS_BORDERO))
                                    },
                                    {
                                        title: le.ordersList,
                                        action: '/orders-3',
                                        show: () => (userPermission.includes(permissions.ORDERS_LIST))
                                    },
                                    {
                                        title: le.ordersListDiscarded,
                                        action: '/orders-4',
                                        show: () => (userPermission.includes(permissions.ORDERS_DISCARDED))
                                    },
                                    {
                                        title: le.ordersReturned,
                                        action: '/orders-7',
                                        show: () => (userPermission.includes(permissions.ORDERS_RETURN) && this.uc.userRole !== Roles.READONLY)
                                    },
                                    {
                                        title: le.orderCredits,
                                        action: '/orders-8',
                                        show: () => (userPermission.includes(permissions.ORDERS_CREDIT) &&
                                            this.hasCreditBox())
                                    }]
                            },
                            {
                                icon: '../images/mainMenu/TrackNTrace.png',
                                title: le.trackAndTrace,
                                action: '/tracking-0',
                                show: () => (userPermission.includes(permissions.TRACKING))
                            },
                            {
                                icon: '../images/mainMenu/Giacenze.png',
                                title: le.stockHandling,
                                action: '/giacenze-0',
                                show: () => (userPermission.includes(permissions.STORAGING))
                            },
                            {
                                icon: '../images/mainMenu/Contrassegni.png',
                                title: le.countersigns,
                                action: '/contrassegni-0',
                                show: () => (userPermission.includes(permissions.COUNTERSIGN))
                            }
                        ]
                    },
                    {
                        title: le.warehouse,
                        show: () => (hasAnyPermission(userPermission, warehousePermissions)),
                        items: [
                            {
                                icon: '../images/mainMenu/Orders.png',
                                title: le.warehouseOrders,
                                subs: [
                                    {
                                        title: le.warehouseordersCreateSingle,
                                        action: '/warehouseOrders-1',
                                        show: () => (userPermission.includes(permissions.WAREHOUSE_ORDERS_CREATE))
                                    },
                                    {
                                        title: le.warehouseOrdersHistory,
                                        action: '/warehouseOrders-2',
                                        show: () => (userPermission.includes(permissions.WAREHOUSE_ORDERS_HISTORY))
                                    },
                                ]
                            },
                            {
                                icon: <i className="fa-duotone fa-solid fa-box-open"></i>,
                                title: le.products,
                                subs: [
                                    {
                                        title: le.registryProduct,
                                        action: '/warehouseProducts-1'
                                    },
                                    {
                                        title: le.returnProducts,
                                        action: '/warehouseProducts-2'
                                    },
                                ],
                                show: () => false /*Disabled*/
                            },
                            {
                                icon: <i className="fa-sharp fa-solid fa-puzzle-piece"></i>,
                                title: le.stock,
                                action: '/warehouseStock-0',
                                show: () => (userPermission.includes(permissions.WAREHOUSE_STOCK))
                            },
                            {
                                icon: <i className="fa-solid fa-chart-mixed"></i>,
                                title: le.forecasts,
                                action: '',
                                show: () => false /*Disabled*/
                            },
                        ]
                    },
                    {
                        title: le.connections,
                        show: () => (hasAnyPermission(userPermission, connectionsPermissions)),
                        items: [
                            {
                                icon: '../images/mainMenu/Couriers.png',
                                title: le.couriers,
                                action: '/couriers-0',
                                show: () => (userPermission.includes(permissions.COURIER))
                            },
                            {
                                icon: '../images/mainMenu/Marketplaces.png',
                                title: le.marketplaces,
                                action: '/marketplaces-0',
                                show: () => (userPermission.includes(permissions.MARKETPLACE))
                            }]
                    },
                    {
                        title: le.settings,
                        show: () => (hasAnyPermission(userPermission, settingsSectionPermissions)),
                        items: [
                            {
                                icon: '../images/mainMenu/Settings.png',
                                title: le.settings,
                                show: () => (hasAnyPermission(userPermission, settingsPermissions)),
                                //action: '/settings-0',
                                subs: [
                                    {
                                        title: le.company,
                                        action: '/settings-1',
                                        show: () => (userPermission.includes(permissions.SETTINGS_COMPANY))
                                    },
                                    {
                                        title: le.addresses,
                                        action: '/settings-2',
                                        show: () => (hasAnyPermission(userPermission, settingsAddressPermissions)),
                                        subs: [
                                            {
                                                title: le.senderAddressses,
                                                action: '/settings-5',
                                                show: () => (userPermission.includes(permissions.SETTINGS_ADDRESS_SENDER))
                                            },
                                            {
                                                title: le.recipientAddresses,
                                                action: '/settings-6',
                                                show: () => (hasAnyPermission(userPermission, settingsAddressRecipientPermissions))
                                            },
                                        ]
                                    },
                                    {
                                        title: le.package,
                                        action: '/settings-4',
                                        show: () => (userPermission.includes(permissions.SETTINGS_PACKAGES))
                                    },
                                    {
                                        title: le.labels,
                                        action: '/settings-3',
                                        show: () => (userPermission.includes(permissions.SETTINGS_LABELS))
                                    }

                                ]
                            },
                            {
                                icon: '../images/mainMenu/Notifications.png',
                                title: le.notifications,
                                action: '/notifications-0',
                                show: () => (userPermission.includes(permissions.COMUNICATION))
                            }
                        ]
                    }
                    /*, {
                        title: le.s4.title,
                        items: [
                            {
                                icon: '../images/mainMenu/User.png', title: le.s4.i1.title, action: '/user-0', subs: [
                                    { title: le.s4.i1.si1, action: '/user-1' },
                                    { title: le.s4.i1.si2, click: this.logoutClick }
                                ]
                            }
                        ]
                    }*/
                ]
        };

        /*if (this.uc && this.uc.userRole === ProfileLevels[2]) {*/
        if (this.uc && this.uc.userRole === Roles.READONLY) {
            for (let i = 1; i <= 4; i++)
                this.menu.sections[2].items[0].subs.shift(); //removes all orders except lists

            this.menu.sections[2].items.pop(); //removes contrassegni
            this.menu.sections.pop(); // removes impostazioni
            this.menu.sections.pop(); // removes connessioni
            //this.menu.sections.pop(); // removes notifications
            //this.menu.sections.pop(); // removes settings
        }
    }

    loggedIn() {
        //this.setState({ login: false, msgmodal: 0, forcedSelection: [1, 1, 0] });
        const userContext = readUserContext();

        if (!userContext) {
            this.logoutClick();
            return;
        }

        this.uc = userContext;

        this.setmenu();

        this.setState({ login: false, msgmodal: 0, paypalClientId: this.uc.payPalClientId });
        this.navigateTo("DASHBOARD");
        //this.hasPrivacy = (this.uc != undefined && this.uc.hasOwnProperty("privacyConsent") ? this.uc.privacyConsent : false);

        if (!this.hasPrivacyConsent()) {
            this.popupPrivacyConsent(true);
        }
        else {
            this.loaderHide();
        }

        this.reminderTimer = setTimeout(() => {
            this.remindersHandler();
        }, 3000);
    }
    logoutClick(ev, keys) {
        //sessionStorage.removeItem("userContext");
        clearUserContext();
        if (this.context) {
            this.context.clearAuthorization();
        }
        this.uc = null;
        clearTimeout(this.reminderTimer);
        this.reminderTimer = null;
        this.setState({ login: true });

    }

    setInvoicing(value) {
        this.uc.invoicing = value;
    }

    remindersHandler() {
        try {
            this.reminderTimer = setTimeout(this.remindersHandler, 60 * 60 * 1000);
            getReminders(this.uc.jwtToken, (response) => {
                this.popupReminders(response);
            });
        }
        catch (e) {
        }
    }

    popupReminders(data) {
        /*
         * data = {
         *  marketplaceConfs: dtos,
         *  reminders: []
         * }
         */
        try {
            let obj = {
                title: "Reminders",
                icon: "info",
                messages: [],
                buttons: [{ name: "ok", type: "confirm", text: "ok", class: "right" }]
            };


            data.reminders.forEach(rem => {
                switch (rem.reminderType) {
                    case "EBAY_TOKEN_EXPIRED":
                        obj.messages.push(Languages.getSection("Ebay").mustRenewToken);
                        break;

                }
            });
            if (obj.messages.length > 0) {
                this.popupMessage(obj);
            }
        }
        catch (e) {
        }
    }

    popupPrivacyConsent(open) {

        if (open)
            this.setState({ msgmodal: 3 });
        else
            this.setState({ msgmodal: 0 });
    }
    popupMessage(msgObj) {
        let genericMsg = JSON.parse(JSON.stringify(msgObj));
        genericMsg.buttons.forEach((el, idx) => {
            var ths = this;
            el.click = function () {
                ths.popupMessageClose();
                if (!!msgObj.buttons[idx].click) msgObj.buttons[idx].click.apply(null, arguments);
            };
        }, this);
        this.setState({ msgmodal: 2, genericMsg: genericMsg });
    }

    popupMessageClose() {
        this.setState({ msgmodal: 0, genericMsg: {} });
    }

    popupErrorMessage(errorMessage) {

        let msg;
        if (errorMessage == undefined || errorMessage == null || errorMessage.length == 0) {
            msg = [this.leMain.messages.msgError.messages[0]];
        }
        else if (Array.isArray(errorMessage))
            msg = errorMessage;
        else
            msg = [errorMessage];

        this.setState({ msgmodal: 4, errorMessage: msg });
    }
    popupErrorMessageClose() {
        this.setState({ msgmodal: 0, errorMessage: '' });
    }

    showLoader(msgNo) {
        this.setState({ msgmodal: 9, genericMsg: msgNo });
    }
    loaderHide() {
        this.setState({ msgmodal: 0 });
    }
    buildRoute() {

        let creditBox = "";
        if (this.hasCreditBox())
            creditBox = (<Route path="/orders-7" component={CreditBox} />);
        return (<Switch>
            <Route exact path="/how2sendapro" component={How2SendaPro} />
            <Route exact path="/mysendapro" component={MySendaPro} />
            <ProtectedRoute
                path="/orders-1"
                component={OrderCreation}
                permission={permissions.ORDERS_CREATE}
            />
            <ProtectedRoute
                path="/orders-2"
                component={SingleOrderCreation}
                permission={permissions.ORDERS_CREATE_SINGLE}
            />
            <ProtectedRoute
                path="/orders-3"
                component={OrdersList}
                permission={permissions.ORDERS_LIST}
            />
            <ProtectedRoute
                path="/orders-4"
                component={DiscardedOrdersList}
                permission={permissions.ORDERS_DISCARDED}
            />
            <ProtectedRoute
                path="/orders-5"
                component={Bordero}
                permission={permissions.ORDERS_BORDERO}
            />
            <ProtectedRoute
                path="/orders-6"
                component={OrderHistory}
                permission={permissions.ORDERS_HISTORY}
            />
            <ProtectedRoute
                path="/orders-7"
                component={OrdersReturned}
                permission={permissions.ORDERS_RETURN}
                additionalCondition={
                    this.uc &&
                    this.uc.userRole !== Roles.READONLY
                }
            />

            {creditBox}

            <ProtectedRoute
                path="/tracking-0"
                component={Tracking}
                permission={permissions.TRACKING}
            />
            <ProtectedRoute
                path="/contrassegni-0"
                component={Countersigns}
                permission={permissions.COUNTERSIGN}
                additionalCondition={
                    this.uc &&
                    this.uc.userRole !== Roles.READONLY
                }
            />
            <ProtectedRoute
                path="/giacenze-0"
                component={Storaging}
                permission={permissions.STORAGING}
            />
            <ProtectedRoute
                path="/warehouseOrders-1"
                component={WarehouseSingleOrderCreation}
                permission={permissions.WAREHOUSE_ORDERS_CREATE}
            />
            <ProtectedRoute
                path="/warehouseOrders-2"
                component={WarehouseOrdersHistory}
                permission={permissions.WAREHOUSE_ORDERS_HISTORY}
            />
            {/*<ProtectedRoute*/}
            {/*    path="/warehouseProducts-1"*/}
            {/*    component={WarehouseReturnProducts}*/}
            {/*/>*/}
            {/*<ProtectedRoute*/}
            {/*    path="/warehouseProducts-2"*/}
            {/*    component={WarehouseRegisrtyProducts}*/}
            {/*/>*/}
            <ProtectedRoute
                path="/warehouseStock-0"
                component={WarehouseStock}
                permission={permissions.WAREHOUSE_STOCK}
            />
            <ProtectedRoute
                path="/couriers-0"
                component={Couriers}
                permission={permissions.COURIER}
            />
            <ProtectedRoute
                path="/marketplaces-0"
                component={Marketplaces}
                permission={permissions.MARKETPLACE}
            />
            <ProtectedRoute
                path="/settings-0"
                component={Company}
                permission={permissions.SETTINGS_COMPANY}
            />
            <ProtectedRoute
                path="/settings-1"
                component={Company}
                permission={permissions.SETTINGS_COMPANY}
            />
            <ProtectedRoute
                path="/settings-5"
                component={SenderAddresses}
                permission={permissions.SETTINGS_ADDRESS_SENDER}
            />
            <ProtectedRoute
                path="/settings-6"
                component={RecipientAddresses}
                anyOf={settingsAddressRecipientPermissions}
            />

            <ProtectedRoute
                path="/settings-3"
                component={Labels}
                permission={permissions.SETTINGS_LABELS}
            />
            <ProtectedRoute
                path="/settings-4"
                component={PackageConfig}
                permission={permissions.SETTINGS_PACKAGES}
            />
            <ProtectedRoute
                path="/notifications-0"
                component={Notifications}
                permission={permissions.COMUNICATION}
            />
            <Route
                path="/user-0"
                component={UserProfile}
            />
            <Route
                path="/user-1"
                component={UserProfile}
            />

        </Switch>);


    }
    render() {

        if (this.state.externalRouting != "") {
            return (<BrowserRouter>
                <div>
                    <Switch>
                        <Route path="/monetaWebStart" component={MonetaWebStart} />
                        <Route path="/monetaWebResult" component={MonetaWebResult} />
                        <Route path="/monetaWebFailed" component={MonetaWebFailed} />
                        <Route path="/ebayWebAccessResult" component={EbayWebAccessResult} />
                    </Switch>
                    <Redirect to={this.state.redirectRoute} />
                </div>
            </BrowserRouter>);

        }

        const publicAuthenticationRoutes = [
            "/forgot-password",
            "/reset-password",
            "/verify-recovery-mail"
        ];

        const isPublicAuthenticationRoute =
            publicAuthenticationRoutes.some(route =>
                window.location.pathname.endsWith(route)
            );

        if (this.state.login || isPublicAuthenticationRoute) {
            return (
                <Switch>
                    <Route
                        exact
                        path="/forgot-password"
                        component={ForgotPassword}
                    />

                    <Route
                        exact
                        path="/reset-password"
                        component={ResetPassword}
                    />

                    <Route
                        exact
                        path="/verify-recovery-mail"
                        component={VerifyRecoveryMail}
                    />

                    <Route
                        render={() =>
                            <Login onLogin={this.loggedIn} />
                        }
                    />
                </Switch>
            );
        }

        let modal = null;
        switch (this.state.msgmodal) {
            case 1: {
                let data = JSON.parse(JSON.stringify(Languages.Main[Languages.selectedLanguage].messages.msgSetProfile));
                let buttons = { buttons: [{ text: data.buttons.ok.text, click: this.msgSetProfile_OK }] };
                delete data.buttons;
                modal = (<MessageBox data={Object.assign(data, buttons)} />);
            }
                break;
            case 2: {
                const data = this.state.genericMsg;
                modal = (<MessageBoxFluid title={data.title} width={data.width || null} icon={data.icon} messages={data.messages} buttons={data.buttons} />);
            }
                break;
            case 3: {

                modal = (<PrivacyMessageBoxFluid privacyConfirmed={this.privacyConfirmed} userContext={this.uc} />);
            }
                break;
            case 4: {

                modal = (<ErrorMessageBox messages={this.state.errorMessage} closeModal={this.popupErrorMessageClose} />);
            }
                break;
            case 9: {
                const le = Languages.Main[Languages.selectedLanguage].messages.loader.messages;
                let msg = !le[this.state.genericMsg] ? le[0] : le[this.state.genericMsg];
                modal = (<LoaderBox message={msg} />);
            }
                break;
            default:
                break;
        }

        let redirect = null;

        if (this.state.navigateTo.redirect != "" && this.state.navigateTo.redirect !== window.location.pathname) {
            if (this.state.navigateTo.params) {
                redirect = (<Redirect to={{
                    pathname: this.state.navigateTo.redirect,
                    state: { params: this.state.navigateTo.params }
                }} />);
            }
            else {
                redirect = (<Redirect to={this.state.navigateTo.redirect} />);
            }
        }


        var testClientId = 'Aakw6oTO5bYjVdpOk-IzBMPTgEudxK5zBHCtbwlnmpwaeiVvvTAGiXTPkZjn9PXHmeWApONPeD-x9adA';
        var prodClientId = 'AeCPWqkgsHF5psDNrz95aYL1TxADHuIAilAfWnWMPm6OjzEUEhZEOGjD1-MeuESZqrgaxUxZF5KRlWXh';
        var ppClientId = document.location.host == "sendapro.sendabox.it" ? prodClientId : testClientId;

        return <PayPalScriptProvider options={{ "client-id": ppClientId, "currency": "EUR" }}>
            <BrowserRouter>
                <div className="full-panel">
                    <div id="nav">
                        <MainMenu sections={this.menu.sections} checks={this.generalChecks} />
                    </div>
                    <div id="page" ref={this.pageRef}>
                        <Switch>
                            <Route exact path="/how2sendapro" component={How2SendaPro} />
                            <Route exact path="/mysendapro" component={MySendaPro} />
                            <ProtectedRoute
                                path="/orders-1"
                                component={OrderCreation}
                                permission={permissions.ORDERS_CREATE}
                            />
                            <ProtectedRoute
                                path="/orders-2/:orderId?"
                                component={SingleOrderCreation}
                                permission={permissions.ORDERS_CREATE_SINGLE}
                            />
                            <ProtectedRoute
                                path="/orders-3"
                                component={OrdersList}
                                permission={permissions.ORDERS_LIST}
                            />
                            <ProtectedRoute
                                path="/orders-4"
                                component={DiscardedOrdersList}
                                permission={permissions.ORDERS_DISCARDED}
                            />
                            <ProtectedRoute
                                path="/orders-5"
                                component={Bordero}
                                permission={permissions.ORDERS_BORDERO}
                            />
                            <ProtectedRoute
                                path="/orders-6"
                                component={OrderHistory}
                                permission={permissions.ORDERS_HISTORY}
                            />
                            <ProtectedRoute
                                path="/orders-7"
                                component={OrdersReturned}
                                permission={permissions.ORDERS_RETURN}
                                additionalCondition={
                                    this.uc &&
                                    this.uc.userRole !== Roles.READONLY
                                }
                            />

                            <ProtectedRoute
                                path="/orders-8"
                                component={CreditBox}
                                permission={permissions.ORDERS_CREDIT}
                                additionalCondition={this.hasCreditBox()}
                            />

                            <ProtectedRoute
                                path="/tracking-0"
                                component={Tracking}
                                permission={permissions.TRACKING}
                            />
                            <ProtectedRoute
                                path="/contrassegni-0"
                                component={Countersigns}
                                permission={permissions.COUNTERSIGN}
                                additionalCondition={
                                    this.uc &&
                                    this.uc.userRole !== Roles.READONLY
                                }
                            />
                            <ProtectedRoute
                                path="/giacenze-0"
                                component={Storaging}
                                permission={permissions.STORAGING}
                            />
                            <ProtectedRoute
                                path="/warehouseOrders-1/:orderId?"
                                component={WarehouseSingleOrderCreation}
                                permission={permissions.WAREHOUSE_ORDERS_CREATE}
                            />
                            <ProtectedRoute
                                path="/warehouseOrders-2"
                                component={WarehouseOrdersHistory}
                                permission={permissions.WAREHOUSE_ORDERS_HISTORY}
                            />
                            {/*<ProtectedRoute*/}
                            {/*    path="/warehouseProducts-1"*/}
                            {/*    component={WarehouseReturnProducts}*/}
                            {/*/>*/}
                            {/*<ProtectedRoute*/}
                            {/*    path="/warehouseProducts-2"*/}
                            {/*    component={WarehouseRegisrtyProducts}*/}
                            {/*/>*/}
                            <ProtectedRoute
                                path="/warehouseStock-0"
                                component={WarehouseStock}
                                permission={permissions.WAREHOUSE_STOCK}
                            />
                            <ProtectedRoute
                                path="/couriers-0"
                                component={Couriers}
                                permission={permissions.COURIER}
                            />
                            <ProtectedRoute
                                path="/marketplaces-0"
                                component={Marketplaces}
                                permission={permissions.MARKETPLACE}
                            />
                            <ProtectedRoute
                                path="/settings-0"
                                component={Company}
                                permission={permissions.SETTINGS_COMPANY}
                            />
                            <ProtectedRoute
                                path="/settings-1"
                                component={Company}
                                permission={permissions.SETTINGS_COMPANY}
                            />
                            <ProtectedRoute
                                path="/settings-5"
                                component={SenderAddresses}
                                permission={permissions.SETTINGS_ADDRESS_SENDER}
                            />
                            <ProtectedRoute
                                path="/settings-6"
                                component={RecipientAddresses}
                                anyOf={settingsAddressRecipientPermissions}
                            />

                            <ProtectedRoute
                                path="/settings-3"
                                component={Labels}
                                permission={permissions.SETTINGS_LABELS}
                            />
                            <ProtectedRoute
                                path="/settings-4"
                                component={PackageConfig}
                                permission={permissions.SETTINGS_PACKAGES}
                            />
                            <ProtectedRoute
                                path="/notifications-0"
                                component={Notifications}
                                permission={permissions.COMUNICATION}
                            />
                            <Route
                                path="/user-0"
                                component={UserProfile}
                            />
                            <Route
                                path="/user-1"
                                component={UserProfile}
                            />
                        </Switch>
                        {redirect}
                    </div>
                    {modal}
                </div>
            </BrowserRouter>
        </PayPalScriptProvider>;
    }
}
